import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="messages--auto-scroll"
export default class extends Controller {
  static targets = ["list", "item"];

  itemTargetConnected(element) {
    if (element === this.listTarget.lastElementChild) {
      this.scrollToLastMessage();
    }
  }

  scrollToLastMessage() {
    this.listTarget.lastElementChild.scrollIntoView(true);
  }
}
